// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q5-0";